export default function($element, setup = {}) {
    if (!$element.dataset.modules) {
        $element.dataset.modules = setup.modules;
    } else {
        $element.dataset.modules += ' ' + setup.modules;
    }

    if (!$element.dataset.hydration) {
        $element.dataset.hydration = setup.hydration || 'whenVisible';
    } else {
        $element.dataset.hydration += ' ' + (setup.hydration || 'whenVisible');
    }

    if (setup.interactionEvents) {
        if (!$element.dataset.interactionEvents) {
            $element.dataset.interactionEvents = setup.interactionEvents;
        } else {
            $element.dataset.interactionEvents += ' ' + setup.interactionEvents;
        }
    }

    if (setup.globalEvents) {
        if (!$element.dataset.globalEvents) {
            $element.dataset.globalEvents = setup.globalEvents;
        } else {
            $element.dataset.globalEvents += ' ' + setup.globalEvents;
        }
    }
}